export default __webpack_public_path__ + "static/graphik-semibold-web-6f392fc881684a9e2c3cc3c4d7eec7d0.woff2";